import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  context: state => state.context,
  formModalOpened: state => state.formModalOpened,
  formModalAdditionalContext: state => state.formModalAdditionalContext,

  scheduleFromContext: (state, getters) => (
    state.context ? getters.find(state.context) : null
  ),

  schedules: (state, getters, rootState, rootGetters) => (
    rootGetters['entities/users/currentUser'] ? getters.query().where('user_id', rootGetters['entities/users/currentUser'].id).get() : []
  ),

};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/getters.js